import axios from "axios";
import AuthService from '../Auth/AuthService';
//import config from '../Auth/Config';

export default class GroupService extends AuthService {

    findAll() {
        return axios({
            method: 'get',
            url: this.api_url + 'grupos',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        }).then(res => res.data);
    }
    findById(codigo) {
        return axios({
            method: 'get',
            url: this.api_url + 'grupos/' + codigo,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        }).then(res => res.data);
    }
    create(dados) {
        return axios({
            method: 'post',
            url: this.api_url + 'grupos',
            data: dados,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
    update(codigo, data) {
        return axios({
            method: 'put',
            url: this.api_url + 'grupos/' + codigo,
            data: data,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
    delete(codigo) {
        return axios({
            method: 'delete',
            url: this.api_url + 'grupos/' + codigo,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
}
